import styled from "styled-components";
import { Ul } from "../elements";

export const LogoList = styled(Ul)`
justify-content: space-between;
column-gap: 62px;
margin: 40px 0 0;
`;

